import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { Select } from 'antd';

@inject("transStore")
@observer
class CarriersSelectBox extends Component {
  state= {
    orTracker: ""
  };

  UNSAFE_componentWillMount() {
    this.getCarriers();
  }

  // 택배사 목록 조회 API
  getCarriers = () => {
    this.props.transStore.disCarriersList();
  };

  render() {
    const { 
      carriersList,
    } = this.props.transStore;
    const { setTracker, tracker, propsDisabled } = this.props;
    const { orTracker } = this.state;
    return (
      <Fragment>
        <Select
          style={{ width: '100%' }}
          disabled={propsDisabled !== undefined && propsDisabled !== null ? propsDisabled : false} 
          value={tracker !== undefined && tracker !== null ? tracker : orTracker} 
          onChange={(value)=>{
            this.setState({orTracker: value});
            setTracker(value);
          }}
        >
          {carriersList.length > 0 && carriersList.map(item=>{
            return(
            <Select.Option key={item.id}>{item.name}</Select.Option>
            )
          })}
        </Select>
      </Fragment>
    );
  }

}

export default CarriersSelectBox;
